import React from 'react';
import Counter from '../ReusableComponents/counter';

//MUI
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Container } from '@mui/system';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

//Images
import im2 from '../../assets/images/SDG/2.jpg';
import im6 from '../../assets/images/SDG/6.jpg';
import im7 from '../../assets/images/SDG/7.jpg';
import im8 from '../../assets/images/SDG/8.jpg';
import im9 from '../../assets/images/SDG/9.jpg';
import im10 from '../../assets/images/SDG/10.jpg';
import im11 from '../../assets/images/SDG/11.jpg';
import im12 from '../../assets/images/SDG/12.jpg';
import im13 from '../../assets/images/SDG/13.jpg';
import im14 from '../../assets/images/SDG/14.jpg';
import im15 from '../../assets/images/SDG/15.jpg';
import P2 from '../../assets/images/cardImages/sustainable_product.jpg';
import bg from '../../assets/images/background.svg'
import ScienceRoundedIcon from '@mui/icons-material/ScienceRounded';
import RecyclingRoundedIcon from '@mui/icons-material/RecyclingRounded';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';

const counterData = [
    {
        "num": 45,
        "label": "R&D Investments towards environmental and social impacts",
        "icon": ScienceRoundedIcon,
        "prefix": "",
        "isdecimal": false,
        "suffix": "%"
    },
    {
        "num": 2413.80,
        "label": "Plastics reclaimed was recycled",
        "icon": RecyclingRoundedIcon,
        "prefix": "",
        "isdecimal": true,
        "suffix": "MT"
    },
    {
        "num": 0,
        "label": "for SUVs undertaken",
        "icon": InventoryOutlinedIcon,
        "prefix": "Life Cycle Assessments ",
        "isdecimal": true,
        "suffix": ""
    },
]

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledBox = styled(Box)`
  ${({ theme }) => `
  cursor: pointer;
  transition: ${theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.standard,
})};
  &:hover {
    transform: scale(2);
  }
  `}
`;


const Sectionc2 = () => {
    const [expanded1, setExpanded1] = React.useState(false);
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };

    const [expanded2, setExpanded2] = React.useState(false);
    const handleExpandClick2 = () => {
        setExpanded2(!expanded2);
    };

    const [expanded4, setExpanded4] = React.useState(false);
    const handleExpandClick4 = () => {
        setExpanded4(!expanded4);
    };

    const [expanded5, setExpanded5] = React.useState(false);
    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    };

    const [expanded6, setExpanded6] = React.useState(false);
    const handleExpandClick6 = () => {
        setExpanded6(!expanded6);
    };

    const [expanded7, setExpanded7] = React.useState(false);
    const handleExpandClick7 = () => {
        setExpanded7(!expanded7);
    };


    const [expanded9, setExpanded9] = React.useState(false);
    const handleExpandClick9 = () => {
        setExpanded9(!expanded9);
    };

    const [expanded10, setExpanded10] = React.useState(false);
    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    };

    const [expand, setExpand] = React.useState(false);
    const expandAll = () => {
        setExpand(true);
        setExpanded1(true);
        setExpanded2(true);
        setExpanded4(true);
        setExpanded5(true);
        setExpanded6(true);
        setExpanded7(true);
        setExpanded9(true);
        setExpanded10(true);
    };
    const closeAll = () => {
        setExpand(false);
        setExpanded1(false);
        setExpanded2(false);
        setExpanded4(false);
        setExpanded5(false);
        setExpanded6(false);
        setExpanded7(false);
        setExpanded9(false);
        setExpanded10(false);
    };


    return (
        <Container>
            <Box mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button startIcon={<WestIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc1'>
                    Previous
                </Button>
                <Button endIcon={<EastIcon />} sx={{ fontWeight: 'bold' }} href='/sectionc3'>
                    Next
                </Button>
            </Box>
            <Box mt={3} sx={{
                display: 'flex',
                alignItems: 'center',
                height: { xs: '150px', md: '300px' },
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                borderRadius: '8px'
            }}>
                <Box px={5} py={3} sx={{ width: '100%' }}>
                    <Typography sx={{ typography: { xs: 'h5', md: 'h4' }, color: "#ffffff" }}>
                        Principle 2
                    </Typography>
                    <Typography mt={2} sx={{ typography: { xs: 'body1', md: 'h6' }, color: "#ffffff" }}>
                        Sustainable Product
                    </Typography>
                    <Box mt={2} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <Typography variant='body1' sx={{ color: "#ffffff" }}>
                            Businesses should provide goods and services in a manner that is sustainable and safe
                        </Typography>
                    </Box>
                    <Box mt={3} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                        <StyledBox><img src={im2} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im6} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im7} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im8} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im9} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im10} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im11} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im12} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im13} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im14} height="40" alt="svg" /></StyledBox>
                        <StyledBox><img src={im15} height="40" alt="svg" /></StyledBox>
                    </Box>
                </Box>
                <Box sx={{
                    backgroundImage: `url(${P2})`,
                    backgroundSize: 'cover',
                    borderRadius: '0 8px 8px 0',
                    height: { xs: '150px', md: '300px' },
                    width: '100%'
                }}>
                </Box>
            </Box>
            <Box px={4} py={6} mt={{ xs: 4, md: 8 }} sx={{ backgroundColor: '#e6e7e8', borderRadius: '8px' }}>
                <Box mb={6} display="flex" justifyContent="center">
                    <Typography className='heading' variant='h4' sx={{ color: "#e31837", fontSize: "34px", fontWeight: "900" }}>
                        Highlights
                    </Typography>
                </Box>
                <Box>
                    <Counter data={counterData} />
                </Box>
            </Box>
            <Box mt={5} sx={{ textAlign: "right" }}>
                <button onClick={!expand ? expandAll : closeAll} className="custom-button">
                    <span>
                        {!expand ? 'Expand All' : "Close All"}
                        {!expand ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                    </span>
                </button>
            </Box>
            <Box mt={4}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Essential Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Percentage of R&amp;D and capital expenditure (capex) investments in specific technologies to improve the environmental and social impacts of product and processes to total R&amp;D and capex investments
                            made by the entity, respectively.
                            <ExpandMore
                                expand={expanded1}
                                onClick={handleExpandClick1}
                                aria-expanded={expanded1}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded1} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell ><strong>Category</strong></TableCell>
                                        <TableCell align="center" ><strong>FY 2025-26%<br></br>(Current Financial Year)</strong></TableCell>
                                        <TableCell align="center" ><strong>FY 2024-25%<br></br>(Previous Financial Year)</strong></TableCell>
                                        <TableCell align="left" ><strong>Details of improvements in environmental and social impacts</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">R&amp;D</TableCell>
                                        <TableCell align='center'>32*</TableCell>
                                        <TableCell align='center'>45</TableCell>
                                        <TableCell rowSpan={2}>
                                            Electrification Programs and Platforms:
                                            <ul>
                                                <li>Continued investments in electric mobility through development of multiple Electric Vehicle (EV) programs</li>
                                                <li>Implementation and development aligned with Worldwide Harmonised Light vehicles Test Procedure (WLTP) emission regulations across product lines</li>
                                            </ul>
                                            Expansion of Born Electric Vehicle Portfolio:
                                            <ul>
                                                <li>Zero Tailpipe emission &amp; improving air quality</li>
                                                <li>Reducing reliance on Fossil fuel</li>
                                            </ul>
                                            Hybrid and Range Extender Technologies:
                                            <ul>
                                                <li>Reducing fuel consumption and lowering emissions</li>
                                            </ul>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Capex</TableCell>
                                        <TableCell align='center'>39**</TableCell>
                                        <TableCell align='center'>21**</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography mt={2} variant='body2'>* The variation is primarily attributable to a revision in the calculation methodology, resulting in improved classification of qualifying R&amp;D expenditure in line with internal reporting standards. Additionally, the reduction reflects the transition of certain projects from the development phase to commercialization, and optimization of ongoing programmes.<br />
                            ** Capital expenditure related to electric vehicles &amp; other technologies to improve the environmental and social impacts of products and processes is done through a separate entity Mahindra Electric Automobile Limited (MEAL) [a Subsidiary of the Company]. The same has been included in the scope of reporting.</Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. a. Does the entity have procedures in place for sustainable sourcing? (Yes/ No)
                            <ExpandMore
                                expand={expanded2}
                                onClick={handleExpandClick2}
                                aria-expanded={expanded2}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded2} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes
                        </Typography>
                    </Box>
                    <Box mb={5}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            b. If yes, what percentage of inputs were sourced sustainably?
                        </Typography>
                    </Box>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            The Company prioritizes responsible business practices by contributing to environmental protection and enhancing people's performance through green procurement and services while ensuring business growth for the supply chain. The Company has established a robust Supplier Code of Conduct to uphold ethical, environmental, and social standards across its value chain. The Code of Conduct guides suppliers to engage in ethical, responsible, and legal business practices in their operations. This Code is signed by more than 95% of suppliers by its purchase value.<br />
                            The Company has been working to enhance the degree of sustainability associated with its sourcing practices under “ONE SOURCING”. As part of the sourcing strategy, the Company has set up vendor parks near manufacturing plants, source from tightly knit clusters, optimize logistics to reduce fuel consumption, emissions and carbon footprint.<br />
                            Between FY 2023-24 and FY 2025-26, the Company conducted ESG due diligence for 68.1% of suppliers, by value. Of these, 45.8% of suppliers, by value, reported the use of renewable energy, while 59% of suppliers, by value, were recorded to be using recycled water in their operations.<br />
                            In FY 2025-26, 11.9% of suppliers, by value, were covered under ESG due diligence, of which 42% of suppliers, reported the use of renewable energy and 51% of suppliers, reported the use of recycled water. Further, company is exploring potential collaboration with suppliers towards the adaptation of renewable energy through group companies who produce renewable energy.<br />
                            In addition, 43% of suppliers, by value, in the Company's value chain are ISO certified (ISO 14001 or 45001).
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Describe the processes in place to safely reclaim your products for reusing, recycling and disposing at the end of life, for (a) Plastics (including packaging) (b) E-waste (c) Hazardous waste and (d) other
                            waste.

                            <ExpandMore
                                expand={expanded4}
                                onClick={handleExpandClick4}
                                aria-expanded={expanded4}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded4} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            CERO, which is India's first and largest network of vehicle recycling company, is a brand under subsidiary Mahindra MSTC Recycling Private Limited, established in collaboration with Government of India Enterprise (GOI). CERO strives to promote circularity and achieve the goal of zero pollution, wastage and metal scrap imports.
                        </Typography>
                        <Typography mt={3} variant='body1'>
                            <strong>(a) Plastics (including packaging)</strong> <br />
                            Plastic which is being removed from end-of-life vehicle is recycled through agencies authorized by the Pollution Control Board. Granules are prepared from the plastic waste and used as raw material for making new product. The Company does not use any packaging material in its process.<br />
                            The post-consumer plastic packaging waste generated from product and spares are disclosed under Extended Producer Responsibility (‘EPR’) obligations of the Company and its suppliers. Waste management agencies and recyclers authorized by the Pollution Control Board are engaged to fulfil the EPR targets through channelization of plastic packaging waste from post-consumer market and also through procurement of recycling certificates from authorized recyclers.
                        </Typography>
                        <Typography mt={3} variant='body1'>
                            <strong>(b) E-waste</strong> <br />
                            E-waste is recycled through recyclers authorized by the Pollution Control Board as per The E-Waste (Management) Rules, 2022.
                        </Typography>
                        <Typography mt={3} variant='body1'>
                            <strong>(c) Hazardous waste</strong> <br />
                            All hazardous waste from the vehicle is removed before beginning the scrapping process. This includes collection of fluid and CFC. The Hazardous waste (fluid) is sent to agencies authorized by the Pollution Control Board for recycling/refining.
                        </Typography>
                        <Typography mt={3} variant='body1'>
                            <strong>(d) Other waste</strong> <br />
                            All the ferrous and non-ferrous metals are extracted from the vehicle for recycling. Some parts are also sold to end user / garage people for reuse purpose, which are allowed as per Automotive Industry Standard (AIS) 129.<br />
                            Lead-acid battery waste generated in post-consumer market are disclosed under the EPR obligation of battery suppliers to the Company, who ensure recycling through agencies authorized by the Pollution Control Board.<br />
                            The Company aligns with the European Union's ELV Directive, advocating for the responsible dismantling and recycling of End-of-Life Vehicles (ELVs) to minimize environmental impact. Our initiatives include preventing specific heavy metals, de-pollution of fluids, marking polymeric parts, and achieving reuse, recycling, and recovery targets. This directive applies to M1 and N1 vehicle categories, ensuring compliance irrespective of the vehicle's service history. Moreover, all of the Company’s products are designed with 100% recyclability or reusability. We ensure major models are devoid of hazardous materials like Lead, Cadmium, and Mercury. Comprehensive dismantling manuals are readily available for all the Company’s vehicles. To meet EEC directive 2005/64/EC for ELV regulation, we have implemented specialized procedures. Additionally, for European exports we adhere to the EC directive on Recycle, Recovery &amp; Reuse (RRR). Some of our best-selling products such as the XUV700, Scorpio-N and XUV500 have recovery rates above 95%.
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            4. Whether Extended Producer Responsibility (EPR) is applicable to the entity's activities (Yes/ No). If yes, whether the waste collection plan is in line with the Extended Producer Responsibility (EPR) plan
                            submitted to Pollution Control Boards? If not, provide steps taken to address the same.
                            <ExpandMore
                                expand={expanded5}
                                onClick={handleExpandClick5}
                                aria-expanded={expanded5}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded5} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>
                            Yes
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={6}>
                <Typography className='heading' variant='h4' sx={{ fontSize: '28px', color: "#e31837" }}>
                    Leadership Indicators
                </Typography>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            1. Has the entity conducted Life Cycle Perspective/ Assessments (LCA) for any of its products (for manufacturing industry) or for its services (for service industry)? If yes, provide details in the following
                            format?

                            <ExpandMore
                                expand={expanded6}
                                onClick={handleExpandClick6}
                                aria-expanded={expanded6}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded6} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small" >
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" ><strong>NIC Code </strong></TableCell>
                                        <TableCell align="center" ><strong>Name of Product/ Service</strong></TableCell>
                                        <TableCell align="center" ><strong>% of total Turnover contributed</strong></TableCell>
                                        <TableCell align="center" ><strong>Boundary for the Life Cycle Perspective/ Assessment was conducted</strong></TableCell>
                                        <TableCell align="center" ><strong>Whether conducted by independent external agency (Yes/ No)</strong></TableCell>
                                        <TableCell align="center" ><strong>Results communicated in public domain (Yes/ No) If yes, provide the web-link.</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">29101</TableCell>
                                        <TableCell>Monocoque SUV*</TableCell>
                                        <TableCell align='center'>45%</TableCell>
                                        <TableCell align='center'>Cradle to grave</TableCell>
                                        <TableCell align='center'>Yes</TableCell>
                                        <TableCell align='center'>No</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box mt={1}>
                            <Typography variant='body2'>
                                * The Company has undertaken Life Cycle Assessment (LCA) for its automotive sector and aims to scale this effort across its wider product portfolio.
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            2. If there are any significant social or environmental concerns and/ or risks arising from production or disposal of your products/ services, as identified in the Life Cycle Perspective/ Assessments (LCA) or through any other means, briefly describe the same along-with action taken to mitigate the same.
                            <ExpandMore
                                expand={expanded7}
                                onClick={handleExpandClick7}
                                aria-expanded={expanded7}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded7} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <Typography variant='body1'>No significant social or environmental risks were identified from the Life Cycle Assessment (LCA) studies carried out.</Typography>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            3. Of the products and packaging reclaimed at end of life of products, amount (in metric tons) reused, recycled, and safely disposed, as per the following format:
                            <ExpandMore
                                expand={expanded9}
                                onClick={handleExpandClick9}
                                aria-expanded={expanded9}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded9} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" rowSpan={2}><strong></strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2025-26<br></br>(Current Financial Year)</strong></TableCell>
                                        <TableCell align="center" colSpan={3}><strong>FY 2024-25<br></br>(Previous Financial Year)</strong></TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell align="center" ><strong>Reused</strong></TableCell>
                                        <TableCell align="center" ><strong>Recycled</strong></TableCell>
                                        <TableCell align="center" ><strong>Safely Disposed</strong></TableCell>
                                        <TableCell align="center" ><strong>Reused</strong></TableCell>
                                        <TableCell align="center" ><strong>Recycled</strong></TableCell>
                                        <TableCell align="center" ><strong>Safely Disposed</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Plastics (including packaging)</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>6,642.0</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>2,413.80</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">E-waste</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>

                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">Hazardous waste</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>

                                    </TableRow>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell component="th" scope="row">
                                            Other waste
                                        </TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                        <TableCell align='center'>-</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box>
            <Box mt={2} mb={5} sx={{ borderBottom: 1, borderColor: "#d3d3c8" }}>
                <Box mb={2}>
                    <Box>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', color: "#e31837" }}>
                            5. Reclaimed products and their packaging materials (as percentage of products sold) for each product category.
                            <ExpandMore
                                expand={expanded10}
                                onClick={handleExpandClick10}
                                aria-expanded={expanded10}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Typography>
                    </Box>
                </Box>
                <Collapse in={expanded10} timeout="auto" unmountOnExit>
                    <Box mb={5}>
                        <TableContainer component={Paper} m>
                            <Table sx={{ minWidth: 650 }} size="small">
                                <TableHead sx={{ "& th": { color: '#FFFFFF' } }}>
                                    <TableRow sx={{ backgroundColor: "#4d4d4f" }}>
                                        <TableCell><strong>Indicate product category</strong></TableCell>
                                        <TableCell><strong>Reclaimed products and their packaging materials as % of total products sold in respective category</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ "& tr": { borderBottom: "1px solid #C3C4BD" } }}>
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell>Plastics used for protecting or packaging parts of the vehicles sold &amp; Packaging used in Spare Parts Business</TableCell>
                                        <TableCell>
                                            The Company recycled 100% of plastic as part of its EPR Compliance under the Plastic Waste Management Rules, 2016.
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Collapse>
            </Box >
        </Container >
    )
}


export default Sectionc2;